// extracted by mini-css-extract-plugin
export default {"imgDiv":"footer_imgDiv__Qp40b"};